import { Injectable } from "@angular/core";
import { AbstractControl, UntypedFormControl, ValidatorFn } from "@angular/forms";
import { OOVenueService } from "./venue-service";

@Injectable({
	providedIn: "root",
})
export class FormValidationService {
	constructor(private venueService: OOVenueService) {}

	numericValueValidate(allowedCharacters?: string[]): ValidatorFn {
		return (control: AbstractControl): { [key: string]: any } => {
			if (!control.value) {
				return null;
			}
			if (isNaN(control.value)) {
				return { notANumber: true };
			}
			return null;
		};
	}

	phoneValueValidate(): ValidatorFn {
		return (control: AbstractControl): { [key: string]: any } => {
			const regex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
			if (!regex.test(control.value)) return { invalidPhonePatternValue: true };
			return null;
		};
	}

	duplicateValue(c: UntypedFormControl, sourceAry: any[], property: string, omitionProperty?: string, omitionValue?: any): ValidatorFn {
		return (control: AbstractControl): { [key: string]: any } | null =>
			!sourceAry.some((i) => i[property].toLowerCase() === c.value.toLowerCase() && i[omitionProperty] !== omitionValue)
				? null
				: {
						duplicateValue: c.value,
				  };
	}
}
